import React from 'react';

/**
 * Loading
 */
class LoadingResize extends React.Component {

  render() {
    return (
      <div id="loadingResize">
        <img src="/img/loading_s.gif" alt="Loading…" />
      </div>
    );
  }
}

export default LoadingResize;
